/* eslint-disable react/prop-types */
/* eslint-disable no-self-compare */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import PropType from 'prop-types';
import * as React from 'react';

import { Autocomplete, FormControl, FormHelperText, InputLabel, MenuItem } from '@mui/material';
import NInput from './NInput';
import clsx from 'clsx';

function NSearchableDropDown(props) {
  const { value, label, onChange, options, id, multiple, onBlur } = props;

  return (
    <div className='App-inputs input-dropdown'>
      <FormControl fullWidth error={props?.error}>
        <Autocomplete
          labelId={`n-dropdown-select-label${label}`}
          id={id}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          options={options}
          getOptionLabel={(option) => option?.label || ''}
          isOptionEqualToValue={(o, v) => o?.value === v}
          renderInput={(params) => (
            <NInput {...params} label={label} placeholder={label} error={props?.error} />
          )}
          renderOption={(props, option) => (
            <li
              {...props}
              className={clsx(props.className, { 'text-nblue': option?.value === value?.value })}
              key={option.value}
            >
              {option.label}
            </li>
          )}
          {...props}
        />
        {props?.helperText && <FormHelperText>{props?.helperText}</FormHelperText>}
      </FormControl>
    </div>
  );
}

NSearchableDropDown.propTypes = {
  id: PropType.string,
  error: PropType.bool,
  multiple: PropType.bool,
  value: PropType.oneOfType([PropType.any, PropType.any]),
  label: PropType.string,
  helperText: PropType.string,
  onChange: PropType.func,
  onBlur: PropType.func,
  options: PropType.arrayOf(
    PropType.shape({
      label: PropType.oneOfType([PropType.any, PropType.any]),
      value: PropType.oneOfType([PropType.any, PropType.any]),
    }),
  ),
};

NSearchableDropDown.defaultProps = {
  error: false,
  multiple: false,
  value: '',
  id: '',
  label: '',
  helperText: '',
  onChange: () => {},
  onBlur: () => {},
  options: undefined,
};

export default NSearchableDropDown;
